import { ReactNode, useRef } from 'react';

import { ChartSize } from '../../types/chart-renderer-props';
import { useChartSize } from './use-chart-size';

export interface ChartContainerProps {
    children: (size: ChartSize) => ReactNode;
    className?: string;
    minHeight?: number;
}

export const ChartContainer = ({ children, className, minHeight = 160 }: ChartContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const size = useChartSize(containerRef, minHeight);

    return (
        <div
            ref={containerRef}
            className={className ?? 'relative h-full min-h-0 w-full overflow-hidden'}
            style={{ minHeight }}>
            {size.width > 0 ? children(size) : null}
        </div>
    );
};
